// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"0271084b","103":"6b215bbb","177":"8c7928a2","264":"c3ddb855","322":"153bd518","396":"818de1b4","400":"67bb144d","427":"793b69b9","437":"20c34f30","569":"6183ee50","630":"f642e523","759":"e8a22c77","852":"39423f74","872":"2645b285","914":"07f9572c","941":"0343cc28"}[chunkId] + ".chunk.js";
};